// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Messages{width:100%;padding:25px 25px 30px;border-radius:7px;font-family:Roboto-Medium,sans-serif;margin-bottom:20px;display:flex}.Messages.info{background-color:rgba(74,144,226,.06);color:#4a90e2}.Messages.info svg{fill:#4a90e2;margin-right:10px}.Messages.danger{background-color:rgba(244,77,87,.06);color:#f44d57}.Messages.warning{background-color:rgba(253,145,65,.06);color:#fd9141}.Messages.success{background-color:rgba(52,168,83,.06);color:#34a853}", ""]);
// Exports
module.exports = exports;
